import type { SxProps, Theme } from '@repo/shared';

export const styles = {
  root: {
    display: 'flex',
    flexDirection: 'column',
    height: '100vh',
    minHeight: 0,
  },
  headerActions: {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    minHeight: 0,
  },
  body: {
    display: 'flex',
    flex: 1,
    minHeight: 0,
    overflow: 'hidden',
  },
  featuresScrollArea: {
    flex: 1,
    minHeight: 0,
    overflow: 'auto',
  },
  panel: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    minHeight: 0,
    overflow: 'hidden',
    bgcolor: 'background.paper',
    border: 1,
    borderColor: 'divider',
    borderRadius: '12px',
  },
} satisfies Record<string, SxProps<Theme>>;
